export var status = {
    REQUESTED: 0,
    BOOKED: 1,
    CONFIRMED: 2,
    CHECKED_IN: 3,
    IN_PROGRESS: 4,
    READY_FOR_CHECK_OUT: 5,
    PAYMENT: 10,
    COMPLETED: 6,
    NO_SHOW: 7,
    CANCELLED: 8,
    DECLINED: 9,
    PENDING: 11,
    WAITING_PAYMENT_CONFIRMATION: 12,
    ALL: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12],
};
